module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av669-18ef81b53d7d3708fd7b1c76a63c1ff8.jpg";